// Route definitions only; the schemas they refer to stay out of the web bundle.
import type { z } from 'zod';
import { defineRoute } from './route.ts';
import type {
  collectionSchema,
  collectionsResponse,
  copiesResponse,
  copyDetail,
  copyListItem,
  createCollectionBody,
  createCopyBody,
  deleteCollectionBody,
  manualReleaseBody,
  moveCopiesBody,
  releaseSchema,
  renameCollectionBody,
  statusBody,
  suggestionsResponse,
  updateCopyBody,
  updateReleaseBody,
} from './records.ts';

type Ok = z.ZodObject<{ ok: z.ZodLiteral<true> }>;
type Moved = z.ZodObject<{ moved: z.ZodNumber }>;

export const listCollections = defineRoute<{ response: typeof collectionsResponse }>()({ method: 'GET', path: '/api/collections' });
export const createCollection = defineRoute<{ body: typeof createCollectionBody; response: typeof collectionSchema }>()({ method: 'POST', path: '/api/collections', status: 201 });
export const renameCollection = defineRoute<{ body: typeof renameCollectionBody; response: typeof collectionSchema }>()({ method: 'PATCH', path: '/api/collections/:id' });
export const deleteCollection = defineRoute<{ body: typeof deleteCollectionBody; response: Ok }>()({ method: 'DELETE', path: '/api/collections/:id' });
export const moveCopies = defineRoute<{ body: typeof moveCopiesBody; response: Moved }>()({ method: 'POST', path: '/api/copies/move' });
export const listCopies = defineRoute<{ response: typeof copiesResponse }>()({ method: 'GET', path: '/api/collections/:id/copies' });
export const getCopy = defineRoute<{ response: typeof copyDetail }>()({ method: 'GET', path: '/api/copies/:id' });
export const createCopy = defineRoute<{ body: typeof createCopyBody; response: typeof copyListItem }>()({ method: 'POST', path: '/api/copies', status: 201 });
export const updateCopy = defineRoute<{ body: typeof updateCopyBody; response: typeof copyListItem }>()({ method: 'PUT', path: '/api/copies/:id' });
export const setCopyStatus = defineRoute<{ body: typeof statusBody; response: typeof copyListItem }>()({ method: 'PUT', path: '/api/copies/:id/status' });
export const deleteCopy = defineRoute<{ response: Ok }>()({ method: 'DELETE', path: '/api/copies/:id' });
export const restoreCopy = defineRoute<{ response: typeof copyListItem }>()({ method: 'POST', path: '/api/copies/:id/restore' });
export const removePhoto = defineRoute<{ response: typeof copyListItem }>()({ method: 'DELETE', path: '/api/copies/:id/photo' });
export const createRelease = defineRoute<{ body: typeof manualReleaseBody; response: typeof releaseSchema }>()({ method: 'POST', path: '/api/releases', status: 201 });
export const updateRelease = defineRoute<{ body: typeof updateReleaseBody; response: typeof releaseSchema }>()({ method: 'PUT', path: '/api/releases/:id' });
export const getSuggestions = defineRoute<{ response: typeof suggestionsResponse }>()({ method: 'GET', path: '/api/collection/suggestions' });

/** Upload is multipart, so it is called with fetch directly: PUT /api/copies/:id/photo. */
export const PHOTO_PATH = '/api/copies/:id/photo';
export const imagePath = (id: string, size: 'full' | 'thumb' | 'small') => `/api/images/${id}/${size}`;
export const exportPath = (collectionId: string) => `/api/collections/${collectionId}/export.csv`;
